<template>
  <div class="outer">
    <portal-target name="menuTop"></portal-target>
    <div class="menuHead">{{head}}</div>
    <b-tabs pills no-fade
            small no-body id="menuTabs" v-model="tabIndex">
      <b-tab title="pg1" active>
        <b-button-group vertical class="menuGroup">
          <b-button @click="mbClick(11)" :class="btn[11].e">{{ btn[11].c }}</b-button>
          <b-button @click="mbClick(12)" :class="btn[12].e">{{ btn[12].c }}</b-button>
          <b-button @click="mbClick(13)" :class="btn[13].e">{{ btn[13].c }}</b-button>
          <b-button @click="mbClick(14)" :class="btn[14].e">{{ btn[14].c }}</b-button>
          <b-button @click="mbClick(15)" :class="btn[15].e">{{ btn[15].c }}</b-button>
          <b-button @click="mbClick(16)" :class="btn[16].e">{{ btn[16].c }}</b-button>
          <b-button @click="mbClick(17)" :class="btn[17].e">{{ btn[17].c }}</b-button>
          <b-button @click="mbClick(18)" :class="btn[18].e">{{ btn[18].c }}</b-button>
        </b-button-group>
      </b-tab>
      <b-tab title="pg2">
        <b-button-group vertical class="menuGroup">
          <b-button @click="mbClick(21)" :class="btn[21].e">{{ btn[21].c }}</b-button>
          <b-button @click="mbClick(22)" :class="btn[22].e">{{ btn[22].c }}</b-button>
          <b-button @click="mbClick(23)" :class="btn[23].e">{{ btn[23].c }}</b-button>
          <b-button @click="mbClick(24)" :class="btn[24].e">{{ btn[24].c }}</b-button>
          <b-button @click="mbClick(25)" :class="btn[25].e">{{ btn[25].c }}</b-button>
          <b-button @click="mbClick(26)" :class="btn[26].e">{{ btn[26].c }}</b-button>
          <b-button @click="mbClick(27)" :class="btn[27].e">{{ btn[27].c }}</b-button>
          <b-button @click="mbClick(28)" :class="btn[28].e">{{ btn[28].c }}</b-button>
        </b-button-group>
      </b-tab>
      <b-tab title="pg3">
        <b-button-group vertical class="menuGroup">
          <b-button @click="mbClick(31)" :class="btn[31].e">{{ btn[31].c }}</b-button>
          <b-button @click="mbClick(32)" :class="btn[32].e">{{ btn[32].c }}</b-button>
          <b-button @click="mbClick(33)" :class="btn[33].e">{{ btn[33].c }}</b-button>
          <b-button @click="mbClick(34)" :class="btn[34].e">{{ btn[34].c }}</b-button>
          <b-button @click="mbClick(35)" :class="btn[35].e">{{ btn[35].c }}</b-button>
          <b-button @click="mbClick(36)" :class="btn[36].e">{{ btn[36].c }}</b-button>
          <b-button @click="mbClick(37)" :class="btn[37].e">{{ btn[37].c }}</b-button>
          <b-button @click="mbClick(38)" :class="btn[38].e">{{ btn[38].c }}</b-button>
        </b-button-group>
      </b-tab>
      <b-tab title="pg4">
        <b-button-group vertical class="menuGroup">
          <b-button @click="mbClick(41)" :class="btn[41].e">{{ btn[41].c }}</b-button>
          <b-button @click="mbClick(42)" :class="btn[42].e">{{ btn[42].c }}</b-button>
          <b-button @click="mbClick(43)" :class="btn[43].e">{{ btn[43].c }}</b-button>
          <b-button @click="mbClick(44)" :class="btn[44].e">{{ btn[44].c }}</b-button>
          <b-button @click="mbClick(45)" :class="btn[45].e">{{ btn[45].c }}</b-button>
          <b-button @click="mbClick(46)" :class="btn[46].e">{{ btn[46].c }}</b-button>
          <b-button @click="mbClick(47)" :class="btn[47].e">{{ btn[47].c }}</b-button>
          <b-button @click="mbClick(48)" :class="btn[48].e">{{ btn[48].c }}</b-button>
        </b-button-group>
      </b-tab>
    </b-tabs>
    <portal to="menuTop">
      <b-button @click="closeMenu" class="closer">Close</b-button>
      <button @click="toggleDiag" class="togDiag">.</button>
    </portal>
  </div>
</template>

<script>
// eslint-disable-next-line
import utl from '../myUtils';

export default {
  name: 'zmenu',
  props: [
    'head',
  ],
  data() {
    return {
      tabIndex: 0,
      btn: [],
    };
  },
  computed: {
    hasDraft() {
      return this.$store.getters.getHasDraft;
    },
    fonts() {
      return this.$store.getters.getFonts;
    },
    showDiagList() {
      return this.$store.getters.getShowDiagList;
    },
    links() {
      return this.$store.getters.getCustomLinks;
    },
    bpBPV() {
      return this.$store.getters.getBillPayBPV;
    },
    cun() {
      return this.$store.getters.getCuNumber;
    },
  },
  methods: {
    closeMenu() {
      // this.$store.commit('menuResult', 'Close');
      this.$store.commit('closeHam');
      const x = document.getElementById('hamMenu');
      x.classList.toggle('change');
    },
    mbClick(result) {
      if (this.btn[result].e === 'd-b') return;
      // utl.diag(`z-menu - mbClick(${result})`);
      this.$store.commit('menuResult', result);
      if (result > 20 && result < 30) {
        //
      }
    },
    toggleDiag() {
      // utl.diag('Toggle Diag');
      this.$store.commit('setShowDiagList', !this.showDiagList);
      this.closeMenu();
    },
    initPage1() {
      this.btn[11].c = 'Transfer Money'; this.btn[11].e = 'e-b'; // Xfer Money
      this.btn[12].c = 'View Statements'; this.btn[12].e = 'e-b'; // Statement
      this.btn[13].c = 'Change Password'; this.btn[13].e = 'e-b'; // Change PW
      this.btn[14].c = 'Reserved'; this.btn[14].e = 'd-b'; // Bill Pay (disabled)
      if (this.bpBPV === 1) {
        this.btn[14].c = 'Bill Pay Ipay'; this.btn[14].e = 'e-b'; // Bill Pay Ipay
      }
      if (this.bpBPV === 2) {
        if (this.hasDraft === true) {
          this.btn[14].c = 'Bill Pay Coop'; this.btn[14].e = 'e-b'; // Bill Pay Coop
          if (this.cun === 17411) { // Diversified
            this.btn[14].c = 'Perfect Pay';
          }
        }
      }
      this.btn[15].c = 'Reserved'; this.btn[15].e = 'd-b'; // Pending Transactions
      this.btn[16].c = 'Reserved'; this.btn[16].e = 'd-b'; // Loan Application
      this.btn[17].c = 'Reserved'; this.btn[17].e = 'd-b'; // Remote Deposit Capture
      this.btn[18].c = 'Sign Off'; this.btn[18].e = 'x-b'; // Sign Off
    },
    initPage2() {
      for (let i = 1; i < 9; i += 1) {
        if (typeof this.links[i] !== 'undefined') {
          if (this.links[i].valid === true) {
            this.btn[20 + i].c = this.links[i].caption;
            this.btn[20 + i].e = 'e-b';
          }
        }
      }
    },
    initPage3() {
      this.btn[31].c = 'Reserved'; this.btn[31].e = 'd-b';
      this.btn[32].c = 'Reserved'; this.btn[32].e = 'd-b';
      this.btn[33].c = 'Reserved'; this.btn[33].e = 'd-b';
      this.btn[34].c = 'Reserved'; this.btn[34].e = 'd-b';
      this.btn[35].c = 'Reserved'; this.btn[35].e = 'd-b';
      this.btn[36].c = 'Reserved'; this.btn[36].e = 'd-b';
      this.btn[37].c = 'Reserved'; this.btn[37].e = 'd-b';
      this.btn[38].c = 'Reserved'; this.btn[38].e = 'd-b';
    },
    initPage4() {
      this.btn[41].c = 'Help Forum'; this.btn[41].e = 'e-b';
      this.btn[42].c = 'Credit Union Hours'; this.btn[42].e = 'e-b';
      this.btn[43].c = 'Reserved'; this.btn[43].e = 'd-b'; // Email Addresses
      this.btn[44].c = 'Reserved'; this.btn[44].e = 'd-b'; // Alerts / Notifications
      this.btn[45].c = 'Reserved'; this.btn[45].e = 'd-b'; // Setup Security Image
      this.btn[46].c = 'Reserved'; this.btn[46].e = 'd-b'; // Preferences
      this.btn[47].c = 'Reserved'; this.btn[47].e = 'd-b';
      this.btn[48].c = 'Unauthorize Device'; this.btn[48].e = 'x-b';
    },
  },
  created() {
    for (let i = 0; i < 49; i += 1) {
      this.btn[i] = {};
      this.btn[i].c = 'Reserved'; // Caption
      this.btn[i].e = 'd-b'; // Enabled
    }
    this.initPage1();
    this.initPage2();
    this.initPage3();
    this.initPage4();
  },
};
</script>

<style scoped>
  .outer {
    background: #f1fff1;
    border: solid 2px black;
  }
  .menuHead {
    display: block;
    height: 34px;
    font-size: 20px;
    color: black;
    padding: 0px;
    padding-right: 50px;
    border: solid 1px black;
    background: #e1efe1;
  }
  .closer {
    position: absolute;
    right: 3px;
    top: 3px;
    background: #a0ffa0;
    color: black;
    font-weight: bold;
    padding: 0px;
    z-index: 100;
    border: solid 2px black;
  }
  .togDiag {
    position: absolute;
    right: 3px;
    top: 38px;
    width: 30px;
    font-size: 16px;
    color: black;
    font-weight: bold;
    z-index: 100;
    background: #f1fff1;
    color: #f1fff1;
    border: none;
    cursor: default;
  }

  #menuTabs {
    position: relative;
    display: inline-block;
    width: 300px;
    horiz-align: center;
    margin: 0;
    margin-top: 2px;
  }
  .menuGroup {
    position: relative;
    margin: 2px;
    display: inline;
    horiz-align: center;
    width: 100%;
  }
  .e-b { /* Enabled-Button - YES, this is used */
    position: relative;
    margin: 0px;
    margin-top: 3px;
    margin-bottom: 3px;
    width: 98%;
    background: #a0ffa0;
    color: black;
    font-weight: bold;
    font-size: 20px;
    border: solid 2px black;
    cursor: pointer;
  }
  .d-b { /* Disabled-Button - YES, this is used */
    position: relative;
    margin: 0px;
    margin-top: 3px;
    margin-bottom: 3px;
    width: 98%;
    background: #a0ffa0;
    color: grey;
    font-weight: bold;
    font-size: 20px;
    border: solid 2px black;
    cursor: not-allowed;
  }
  .x-b { /* eXit-Button (red) - YES, this is used */
    position: relative;
    margin: 0px;
    margin-top: 3px;
    margin-bottom: 3px;
    width: 98%;
    background-color: red;
    color: black;
    font-weight: bold;
    font-size: 20px;
    border: solid 2px black;
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/components/z-menu.vue